import {DataRow} from '@spa/reporting';

import {ReportTableDataRowInterface} from '..';

export class ReportTableDataRow extends DataRow {
    constructor(data: ReportTableDataRowInterface) {
        super(data);
    }
}
